<template>
    <div class="v-cards">
        <template v-for="value in items">
            <form-applications-item
                :key="value?.id"
                v-bind="{
                    value,
                    list,
                    recruitment: value.recruitment,
                    applications,
                }"
                v-on="{
                    push,
                    pull,
                }"
            />
        </template>
    </div>
</template>

<script>
import FormApplicationsItem from "./form-applications-item.vue";

export default {
    components: {
        FormApplicationsItem,
    },
    props: {
        value: { type: Array, default: () => [] }, // applications
        items: { type: Array, default: () => [] },
        list: { type: Boolean, default: false },
    },
    data: () => ({
        applications: [],
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.applications = [...this.value];
        },
        emit() {
            this.$emit("input", this.applications);
        },
        push(item) {
            this.applications.push(item);
            this.emit();
        },
        pull(item) {
            let index = this.applications.findIndex(({ _id }) => _id == item._id);
            if (-1 < index) this.applications.splice(index, 1);
            this.emit();
        },
    },
};
</script>

<style></style>
